var _circle, _path, _path2, _rect, _rect2, _rect3, _path3, _rect4, _rect5, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _ellipse2, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCommunityEditErrorState = function SvgCommunityEditErrorState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 160 160",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#E6E9ED",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    d: "M20.8 38.8a2 2 0 0 1 2-2h114.4a2 2 0 0 1 2 2v10.8H20.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.8 49.6h118.4v73.2a2 2 0 0 1-2 2H22.8a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.093,
    height: 4.108,
    fill: "#E37570",
    rx: 2.046,
    transform: "matrix(1 0 0 -1 24.893 45.14)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.093,
    height: 4.108,
    fill: "#EFBA0F",
    rx: 2.046,
    transform: "matrix(1 0 0 -1 32.055 45.14)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.093,
    height: 4.108,
    fill: "#4ACC82",
    rx: 2.046,
    transform: "matrix(1 0 0 -1 39.217 45.14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 49.6h24v73.6h-22a2 2 0 0 1-2-2z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64.236,
    height: 50.018,
    x: 44.5,
    y: 63.082,
    fill: "#fff",
    stroke: "#E6E9ED",
    strokeDasharray: "6 6",
    strokeLinejoin: "round",
    strokeMiterlimit: 16,
    rx: 4.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 63.691,
    height: 49.309,
    fill: "#F4F6F8",
    rx: 2,
    transform: "matrix(-1 0 0 1 113.546 58.4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9CED4",
    fillRule: "evenodd",
    d: "M76.613 101.662c-.467-3.528-3.166-5.198-4.348-5.852-1.59-.88-3.798-1.409-6.938-1.409s-5.348.53-6.937 1.41a9.6 9.6 0 0 0-1.845 1.38v2.471a2 2 0 0 0 2 2zm-11.285-9.314c-3.355 0-6.074-2.759-6.074-6.161 0-3.403 2.72-6.161 6.074-6.161s6.073 2.758 6.073 6.16-2.72 6.162-6.073 6.162M106.727 96.687a11 11 0 0 0-1.555-1.001c-1.614-.873-3.857-1.398-7.047-1.398s-5.433.525-7.048 1.398c-1.205.651-3.963 2.71-4.422 5.846h18.783a2 2 0 0 0 1.289-1.87zm-8.602-4.436c-3.407 0-6.17-2.737-6.17-6.113s2.763-6.112 6.17-6.112 6.17 2.737 6.17 6.112-2.763 6.113-6.17 6.113",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9CED4",
    d: "M65.148 101.532h31.543c-.63-4.94-4.424-7.273-6.08-8.185-2.22-1.221-5.306-1.957-9.692-1.957-4.385 0-7.47.736-9.69 1.957-1.657.912-5.45 3.795-6.08 8.185M72.437 79.98c0 4.727 3.798 8.558 8.483 8.558s8.483-3.831 8.483-8.557-3.798-8.558-8.483-8.558-8.484 3.832-8.484 8.558"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE734F",
    d: "m107.662 148.106 10.834-5.977a.945.945 0 0 0 0-1.655l-12.204-6.733-12.204 6.733a.945.945 0 0 0 0 1.655l10.835 5.977a2.83 2.83 0 0 0 2.739 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.182 123.345h-3.78l-5.164 16.195s-.94 4.597 7.054 4.597c7.995 0 7.054-4.597 7.054-4.597z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE734F",
    d: "m112.288 136.22-1.36-4.265c-2.365 2.677-7.337 2.243-9.272.003l-1.359 4.262c.337.982 1.584 3.191 5.995 3.191s5.659-2.209 5.996-3.191M103.027 127.657c.623.733 1.633 1.358 3.265 1.358s2.642-.625 3.265-1.358l-1.375-4.312h-1.162a3.7 3.7 0 0 1-1.364 0h-1.254z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.89,
    cy: 0.945,
    fill: "#FE734F",
    rx: 1.89,
    ry: 0.945,
    transform: "matrix(-1 0 0 1 108.182 122.4)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE734F",
    d: "m18.523 132.906-10.835-5.977a.945.945 0 0 1 0-1.655l12.204-6.733 12.204 6.733a.945.945 0 0 1 0 1.655l-10.834 5.977a2.83 2.83 0 0 1-2.74 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.002 108.145h3.78l5.164 16.195s.94 4.597-7.054 4.597-7.054-4.597-7.054-4.597z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE734F",
    d: "m13.897 121.02 1.36-4.265c2.365 2.677 7.337 2.243 9.271.003l1.36 4.262c-.337.982-1.585 3.191-5.996 3.191-4.41 0-5.659-2.209-5.995-3.191M23.157 112.457c-.623.733-1.632 1.358-3.265 1.358-1.632 0-2.642-.625-3.265-1.358l1.375-4.312h1.163c.452.086.915.083 1.363 0h1.254z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.892,
    cy: 108.145,
    fill: "#FE734F",
    rx: 1.89,
    ry: 0.945
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C9CED4",
    strokeLinecap: "round",
    d: "M11.6 57.6v2.588M16 62h-2.588M11.6 63.812V66.4M9.788 62H7.2M149.2 84v2.588M153.6 88.4h-2.588M149.2 90.212V92.8M147.388 88.4H144.8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCommunityEditErrorState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "community_edit_error_state.svg";